import React from "react";
import "./InfoMessage.scss";
import {strings} from "../../strings/strings";

export const VinInfoMessage = () => {
    return (
        <div>
            <span className={'accent'}>{strings.vehicleVin2}</span> <span
            className={'info-message-grey'}>{strings.vehicleVinDescription}</span>
        </div>
    )
};